import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  title: {
    textAlign: 'center',
  },
  message: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
}))
